import { AccountTransactionList } from "../../tlSalesOnAccount";

const BorrowersList = () => (
  <AccountTransactionList
    title="Borrowers"
    moduleId="MFBowers"
    storageKey="lendingBorrowers.filters"
    accessPath="/api/lending/borrowers/access"
    statusPath="/api/lending/borrowers/status"
    transactionPath="/App/MFBorrowers"
    documentPrefix="BORROWER"
    rowClassPrefix="borrower"
    centeredErrors
    hideCancelAction
    postLabel="ACTIVATE"
    postAction="ACTIVATE"
    postPermission="ACTIVATE"
    unpostLabel="DEACTIVATE"
    unpostAction="DEACTIVATE"
    unpostPermission="DEACTIVATE"
    hideUnauthorizedActions
  />
);

export default BorrowersList;
